const DATA_SAVED = "extragestor/inscripcionesConfirmadas/DATA_SAVED";
const RESET_DATA_SAVED =
  "extragestor/inscripcionesConfirmadas/RESET_DATA_SAVED";
const FETCH = "extragestor/incidencias/FETCH";
const CHANGED = "extragestor/incidencias/CHANGED";
const REMOVED = "extragestor/incidencias/REMOVED";
const RESET = "extragestor/incidencias/RESET";

/*---*/
export { DATA_SAVED, RESET_DATA_SAVED, FETCH, CHANGED, REMOVED, RESET };



// WEBPACK FOOTER //
// ./src/ducks/incidencias/types.js